import { AxiosRequestConfig } from "axios";

import { ApiError } from "@/interfaces/api";
import { FileDownloadResult, FileInfo } from "@/types";

import { fetchData } from "@/api/utils";

type CustomerConnectApiResponse = {
  data: FileDownloadResult;
  error: ApiError | null;
};

export const customerConnect = async (
  accessToken: string,
  fileInfo: FileInfo,
  selection_ids: number[]
): Promise<CustomerConnectApiResponse> => {
  let url = `${process.env.REACT_APP_API_URL}/customer/connect?csv=true&link=true`;
  url = fileInfo.hasHeader ? url : url + `&header=${fileInfo.header}`;
  url =
    selection_ids.length === 0
      ? url
      : url + `&selection=${selection_ids.join()}`;

  const config: AxiosRequestConfig = {
    method: "POST",
    url,
    headers: {
      "content-type": "text/csv",
      Authorization: `Bearer ${accessToken}`,
    },
    data: fileInfo.file,
  };

  return fetchData(config);
};
